<template>
  <div>
    <h1>Show {{ item && item['@id'] }}</h1>

    <div
      v-if="isLoading"
      class="alert alert-info"
      role="status">Loading...</div>
    <div
      v-if="error"
      class="alert alert-danger"
      role="alert">
      <span
        class="fa fa-exclamation-triangle"
        aria-hidden="true" /> {{ error }}
    </div>
    <div
      v-if="deleteError"
      class="alert alert-danger"
      role="alert">
      <span
        class="fa fa-exclamation-triangle"
        aria-hidden="true" /> {{ deleteError }}
    </div>
    <div
      v-if="item"
      class="table-responsive">
      <table class="table table-striped table-hover">
        <thead>
          <tr>
            <th>Field</th>
            <th>Value</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>state</td>
            <td>{{ item['state'] }}</td>
          </tr>
          <tr>
            <td>createdAt</td>
            <td>{{ item['createdAt'] }}</td>
          </tr>
          <tr>
            <td>updatedAt</td>
            <td>{{ item['updatedAt'] }}</td>
          </tr>
          <tr>
            <td>deletedAt</td>
            <td>{{ item['deletedAt'] }}</td>
          </tr>
          <tr>
            <td>createdBy</td>
            <td>{{ item['createdBy'] }}</td>
          </tr>
          <tr>
            <td>updatedBy</td>
            <td>{{ item['updatedBy'] }}</td>
          </tr>
          <tr>
            <td>deletedBy</td>
            <td>{{ item['deletedBy'] }}</td>
          </tr>
          <tr>
            <td>name</td>
            <td>{{ item['name'] }}</td>
          </tr>
          <tr>
            <td>model</td>
            <td>{{ item['model'] }}</td>
          </tr>
          <tr>
            <td>registrationNumber</td>
            <td>{{ item['registrationNumber'] }}</td>
          </tr>
          <tr>
            <td>type</td>
            <td>{{ item['type'] }}</td>
          </tr>
        </tbody>
      </table>
    </div>

    <router-link
      v-if="item"
      :to="{ name: 'EXCMCarList' }"
      class="btn btn-default">Back to list</router-link>
    <button
      class="btn btn-danger"
      @click="deleteItem(item)">Delete</button>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

export default {
  computed: mapGetters({
    deleteError: 'excmcar/del/error',
    error: 'excmcar/show/error',
    isLoading: 'excmcar/show/isLoading',
    item: 'excmcar/show/retrieved'
  }),

  beforeDestroy () {
    this.reset()
  },

  created () {
    this.retrieve(decodeURIComponent(this.$route.params.id))
  },

  methods: {
    ...mapActions({
      del: 'excmcar/del/del',
      reset: 'excmcar/show/reset',
      retrieve: 'excmcar/show/retrieve'
    }),

    deleteItem (item) {
      if (window.confirm('Are you sure you want to delete this item?')) {
        this.del(item).then(() => this.$router.push({ name: 'EXCMCarList' }))
      }
    }
  }
}
</script>
